'use client'

import type { DecorationFieldProps } from './types'

/**
 * Static copy block (instructions / consent text / disclaimers). Decoration
 * block — renders the same prose in preview and live. Markdown is currently
 * rendered as preserved-whitespace plain text (no markdown→HTML pass yet, as
 * in the prior runtime); an empty body shows a faint placeholder in preview.
 */
export function MarkdownField({ props, mode }: DecorationFieldProps<'Markdown'>) {
  const body = props.body?.trim()
  if (!body) {
    return mode === 'preview' ? (
      <p className="text-sm italic text-muted-foreground">Instructions / markdown text</p>
    ) : null
  }
  return (
    <div className="prose prose-sm dark:prose-invert">
      <p className="whitespace-pre-wrap">{body}</p>
    </div>
  )
}
